<template>
  <main>
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Komplain
           <span v-if="processingData.isComplaint" class="badge pl-2 pr-2 badge-danger">{{complaintData.length}}</span>
        </h4>
      </div>
      <div class="col-md-12">
        
        <button
          class="btn btn-primary text-dark col-md"
          type="button"
          data-toggle="modal"
          data-target="#complaintModal"
          id="complainButton"
        >
          <i
            class="fas fa-exclamation float-left mt-1 mb-1 text-light"
            aria-hidden="true"
          ></i>
          <span class="text-light font-weight-normal mb-2">Lihat Komplain </span>
        </button>
      </div>

      <div
        class="modal fade"
        id="complaintModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="complaintModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <div class="modal-title" id="complaintModalLabel">
                <h5 class="card-title font-weight-bold">Komplain</h5>
              </div>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div
                v-if="
                  orderStatusId === '4' ||
                  orderStatusId === '17' ||
                  orderStatusId === '18'
                "
                class="hasComplaint"
              >
                <div class="card-body">
                  <div class="card">
                    <div v-if="!isSendComplaint" class="alert alert-danger">
                      <span
                        ><i class="fa fa-info-circle" aria-hidden="true"></i>
                        Selesaikan komplain yang sedang berlangsung terlebih
                        dahulu</span
                      >
                    </div>

                    <div class="card-header">
                      <h5 class="card-title">Komplain Ke Sekolah</h5>
                    </div>
                    <div class="card-body">
                      <p class="text-muted">
                        Komplain Invoice
                        <b>{{ sectionOrderInformation.invoice }}</b>
                      </p>
                      <form>
                        <div class="form-group">
                          <label for="">Kategori Komplain</label>
                          <select
                            class="form-control"
                            name=""
                            id="complaintCategory"
                            readonly
                          >
                            <option
                              v-if="orderStatusId != '18'"
                              value="0"
                              selected
                            >
                              Pesanan
                            </option>
                            <option
                              v-if="orderStatusId == '18'"
                              value="6"
                              selected
                            >
                              Pembayaran
                            </option>
                          </select>
                        </div>
                        <div class="form-group">
                          <label for="">Alasan</label>
                          <input
                            name=""
                            id="complaintReason"
                            class="form-control"
                            :disabled="!isSendComplaint"
                            placeholder="Apa alasan anda komplain ke sekolah?"
                          />
                        </div>

                        <label for="">Bukti Gambar</label>
                        <p class="small text-muted">
                          Opsional (Tidak wajib diisi)
                        </p>
                        <input type="file" name="" id="complaintPicture" />
                        <div class="pull-right">
                          <button
                            type="button"
                            @click="createComplaint"
                            :disabled="!isSendComplaint"
                            class="btn btn-primary"
                          >
                            Kirim Komplain
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center">
                <a
                  id="filterCollapse"
                  type="button"
                  data-toggle="collapse"
                  data-target="#complaintHistory"
                  aria-expanded="false"
                  aria-controls="complaintHistory"
                  @click="arrowChanger"
                >
                  <span style="color: #414141">
                    <p>
                      <u>Lihat Semua Komplain</u>
                      <i
                        :class="
                          arrow === 0
                            ? 'ml-2 fa fa-caret-down'
                            : 'ml-2 fa fa-caret-up'
                        "
                        aria-hidden="true"
                      ></i>
                    </p>
                  </span>
                </a>
              </div>

              <div v-show="complaintData.length == 0" class="card-body text-center collapsed">
                <!-- <img src="/src/assets/emptyState.jpg" class="img-fluid" alt=""> -->
                <p class="text-muted">Tidak ada komplain</p>
              </div>

              <div
                id="complaintHistory"
                class="card-body collapsed"
                v-for="(cd, index) in complaintData"
                :key="index"
              >
                <div class="row">
                  <div class="col-md-2 ml-3">
                    <p>Status</p>
                    <p
                      :class="
                        cd.isResolved
                          ? 'badge badge-soft-success'
                          : 'badge badge-soft-warning'
                      "
                    >
                      <span v-if="cd.isResolved">Komplain sudah selesai</span>
                      <span v-if="!cd.isResolved">Sedang Berlangsung...</span>
                    </p>
                  </div>
                  <div class="col-md-8 ml-3">
                    <p>Komplain dari</p>
                    <span class="badge badge-secondary">{{
                      cd.from === "user" ? "Sekolah" : user.name
                    }}</span>
                  </div>
                </div>

                <div class="card-on-card card-bordered dataCard">
                  <!-- <div class="card-header">
                    <div
                      class="media media-chat float-left"
                      style="margin: -20px -20px -20px -21.5px"
                    >
                      <img
                        class="img-circle"
                        src="https://img.icons8.com/cotton/64/000000/user-male--v1.png"
                        alt="avatar"
                      />
                      <h4
                        class="card-title mt-3"
                        style="
                          font-size: 14px;
                          background-color: #d8d8d8;
                          color: #808080;
                          border: 0;
                          border-radius: 10px;
                          padding: 1px 10px 1px 10px;
                        "
                      >
                        {{
                          cd.from === "user"
                            ? sectionOrderInformation.school.name
                            : user.name === "user"
                            ? sectionOrderInformation.school.name
                            : user.name
                        }}
                      </h4>
                    </div>
                  </div> -->
                  <div class="col-md mt-4">
                    <div class="alert alert-secondary" id="notif">
                      <div class="row">
                        <div class="col-md-9">
                          <p class="pt-3">
                            <i class="fa fa-info-circle" aria-hidden="true"></i>
                            {{ cd.main }}
                          </p>
                        </div>
                        <div class="col-md-3">
                          <button
                            class="btn btn-secondary pull-right"
                            data-toggle="collapse"
                            href="#imageCollapse"
                            role="button"
                            aria-expanded="false"
                            aria-controls="imageCollapse"
                          >
                            <span class="font-weight-normal"
                              >Gambar Komplain</span
                            >
                          </button>
                          <div class="collapse pull-right" id="imageCollapse">
                            <div class="mb-3">
                              <img
                                height="auto"
                                width="200px"
                                :src="cd.image"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="
                      ps-container ps-theme-default ps-active-y
                      chatBg
                      scrollable
                    "
                    id="chat-content"
                    style="
                      overflow-y: scroll !important;
                      height: 400px !important;
                    "
                  >
                    <main v-for="(comp, index) in cd.message" :key="index">
                      <div v-if="comp.from == 'mall'">
                        <div class="media media-meta-day">
                          {{ comp.createdAt }}
                        </div>
                        <div class="media media-chat media-chat-reverse">
                          <div class="media-body">
                            <div class="text-right">
                              <p>
                                <span
                                  class="text-right font-weight-bold text-white"
                                  >You</span
                                >
                                <br />
                                <span
                                  class="font-weight-bolder text-white"
                                  style="color: #fffff"
                                >
                                  {{ comp.message }}
                                </span>
                              </p>
                              <p class="meta text-dark">{{ comp.createdAt }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div class="media media-chat">
                          <img
                            class="avatar"
                            src="https://img.icons8.com/cotton/64/000000/user-male--v1.png"
                            alt="..."
                          />
                          <div class="media-body">
                            <p
                              :class="
                                comp.from == 'admin' ? 'bg-soft-warning' : ''
                              "
                            >
                              <span
                                class="text-right text-muted"
                                style="font-weight: 500"
                              >
                                {{
                                  comp.name
                                    .toLowerCase()
                                    .split(" ")
                                    .map(
                                      (s) =>
                                        s.charAt(0).toUpperCase() +
                                        s.substring(1)
                                    )
                                    .join(" ")
                                }}
                              </span>
                              <br />
                              <span>
                                {{ comp.message }}
                              </span>
                            </p>
                            <p class="meta">{{ comp.createdAt }}</p>
                          </div>
                        </div>
                      </div>
                    </main>

                    <div
                      class="ps-scrollbar-x-rail"
                      style="left: 0px; bottom: 0px"
                    >
                      <div
                        class="ps-scrollbar-x"
                        tabindex="0"
                        style="left: 0px; width: 0px"
                      ></div>
                    </div>
                    <div
                      class="ps-scrollbar-y-rail"
                      style="top: 0px; height: 0px; right: 2px"
                    >
                      <div
                        class="ps-scrollbar-y"
                        tabindex="0"
                        style="top: 0px; height: 2px"
                      ></div>
                    </div>
                  </div>
                  <div class="publisher bt-1 border-light">
                    <div class="photo">
                      <img
                        class="avatar avatar-xs"
                        :src="user.image.primary"
                        style="
                          background-size: contain;
                          margin: 10px 10px 0px 0px;
                          background-color: white;
                        "
                        alt="..."
                      />
                    </div>
                    <input
                      id="inputComplaint"
                      class="form-control col-md-11"
                      type="text"
                      placeholder="Tulis Pesan..."
                      :disabled="cd.isResolved"
                    />
                    <button
                      class="btn btn-primary"
                      data-abc="true"
                      :disabled="cd.isResolved || loadingState"
                      @click="addComplaint(cd.complaintId)"
                    >
                      <!-- <i
                        id="loadingState"
                        class="fa fa-paper-plane"
                        aria-hidden="true"
                      ></i> -->
                      <i v-show="loadingState" class="fa fa-spin fa-spinner"></i>
                      {{loadingState ? ''  : 'Kirim'}}
                    </button>
                  </div>
                </div>

                <button
                  v-if="(cd.isHasResolve && !cd.isResolved)"
                  type="button"
                  :class="
                    cd.isResolved
                      ? 'btn btn-secondary text-center'
                      : 'btn btn-success text-center'
                  "
                  @click="resolveComplaint(cd.main)"
                >
                  <span v-if="cd.isResolved">Komplain telah selesai!</span>
                  <span v-else>Selesaikan Komplain</span>
                </button>

              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// import axios from 'axios'
import $ from "jquery";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      arrow: 0,
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
  props: {
    complaintData: {},
    orderStatusId: String,
    isSendComplaint: Boolean,
    sectionOrderInformation: {},
    addComplaint: { type: Function },
    resolveComplaint: { type: Function },
    createComplaint: { type: Function },
    loadingState: Boolean,
    processingData:{}
  },
  methods: {
    arrowChanger() {
      if (this.arrow === 0) {
        this.arrow = 1;
        $("#filterCollapse").addClass("active");
      } else {
        this.arrow = 0;
        $("#filterCollapse").addClass("");
      }
    },
  },
};
</script>

<style scoped>
/* .card-bordered {
  border: 1px solid #ebebeb;
} */

input[type="file" i] {
  appearance: none;
  background-color: initial;
  cursor: default;
  align-items: baseline;
  color: inherit;
  text-overflow: ellipsis;
  white-space: pre;
  text-align: start !important;
  padding: initial;
  border: initial;
  overflow: hidden !important;
}

.input {
  -webkit-writing-mode: horizontal-tb !important;
  text-rendering: auto;
  color: -internal-light-dark(black, white);
  letter-spacing: normal;
  word-spacing: normal;
  text-transform: none;
  text-indent: 0px;
  text-shadow: none;
  display: inline-block;
  text-align: start;
  appearance: auto;
  background-color: -internal-light-dark(rgb(255, 255, 255), rgb(59, 59, 59));
  -webkit-rtl-ordering: logical;
  cursor: text;
  margin: 0em;
  font: 400 13.3333px Arial;
  padding: 1px 2px;
  border-width: 2px;
  border-style: inset;
  border-color: -internal-light-dark(rgb(118, 118, 118), rgb(133, 133, 133));
  border-image: initial;
}
.image-source-link {
  color: #98c3d1;
}

.card {
  border: 0;
  border-radius: 0px;
  margin-bottom: 30px;
  -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.03);
  -webkit-transition: 0.5s;
  transition: 0.5s;
}

.padding {
  padding: 3rem !important;
}

.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.card-header {
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
  padding: 15px 20px;
  background-color: transparent;
  /* border-bottom: 1px solid rgba(77, 82, 89, 0.07); */
}

.card-header .card-title {
  padding: 0;
  border: none;
}

/* h4.card-title {
  font-size: 17px;
} */

.card-header > *:last-child {
  margin-right: 0;
}

/* .card-header > * {
  margin-left: 8px;
  margin-right: 8px;
} */

.btn-secondary {
  color: #4d5259 !important;
  background-color: #e4e7ea;
  border-color: #e4e7ea;
  color: #fff;
}

.btn-xs {
  font-size: 11px;
  padding: 2px 8px;
  line-height: 18px;
}

.btn-xs:hover {
  color: #fff !important;
}

/* .card-title {
  font-weight: 300;
  line-height: 1.5;
  margin-bottom: 0;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(77, 82, 89, 0.07);
} */

.ps-container {
  position: relative;
}

.ps-container {
  -ms-touch-action: auto;
  touch-action: auto;
  overflow: hidden !important;
  -ms-overflow-style: none;
}

.media-chat {
  padding-right: 64px;
  margin-bottom: 0;
}

.media {
  padding: 16px 12px;
  -webkit-transition: background-color 0.2s linear;
  transition: background-color 0.2s linear;
}

.media .avatar {
  flex-shrink: 0;
}

.media-chat .media-body {
  -webkit-box-flex: initial;
  flex: initial;
  display: table;
}

.media-body {
  min-width: 0;
}

.media-chat .media-body p {
  position: relative;
  padding: 6px 8px;
  margin: 4px 0;
  background-color: #f5f6f7;
  border-radius: 3px;
  font-weight: 100;
  color: #757575;
}

.media > * {
  margin: 0 8px;
}

.media-chat .media-body p.meta {
  background-color: transparent !important;
  padding: 0;
  opacity: 0.8;
}

.media-meta-day {
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
  margin-bottom: 0;
  color: #8b95a5;
  opacity: 0.8;
  font-weight: 400;
}

.media {
  padding: 16px 12px;
  -webkit-transition: background-color 0.2s linear;
  transition: background-color 0.2s linear;
}

.media-meta-day::before {
  margin-right: 16px;
}

.media-meta-day::before,
.media-meta-day::after {
  content: "";
  -webkit-box-flex: 1;
  flex: 1 1;
  border-top: 1px solid #ebebeb;
}

.media-meta-day::after {
  content: "";
  -webkit-box-flex: 1;
  flex: 1 1;
  border-top: 1px solid #ebebeb;
}

.media-meta-day::after {
  margin-left: 16px;
}

.media-chat.media-chat-reverse {
  padding-right: 12px;
  padding-left: 64px;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  flex-direction: row-reverse;
}

.media-chat {
  padding-right: 64px;
  margin-bottom: 0;
}

.media {
  padding: 16px 12px;
  -webkit-transition: background-color 0.2s linear;
  transition: background-color 0.2s linear;
}

.media-chat.media-chat-reverse .media-body p {
  float: right;
  clear: right;
  background-color: #43576b;
  color: #fff;
}

.media-chat .media-body p {
  position: relative;
  padding: 6px 8px;
  margin: 4px 0;
  background-color: #f5f6f7;
  border-radius: 3px;
}

.border-light {
  border-color: #f1f2f3 !important;
}

.bt-1 {
  border-top: 1px solid #ebebeb !important;
}

.publisher {
  position: relative;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  padding: 12px 20px;
  background-color: #f9fafb;
}

.publisher > *:first-child {
  margin-left: 0;
}

.publisher > * {
  margin: 0 8px;
}

.photo {
  width: 34px;
  height: 34px;
  overflow: hidden;
  float: left;
  z-index: 5;
  margin-right: 10px;
  border-radius: 50%;
  margin-left: 23px;
  /* box-shadow: 0 10px 25px 0 rgba(0, 0, 0, .3); */
}

.publisher-input {
  -webkit-box-flex: 1;
  flex-grow: 1;
  border: none;
  outline: none !important;
  background-color: transparent;
}

button,
input,
optgroup,
select,
textarea {
  /* font-family: Roboto, sans-serif; */
  font-weight: 300;
}

.publisher-btn {
  background-color: transparent;
  border: none;
  color: #8b95a5;
  font-size: 16px;
  cursor: pointer;
  overflow: -moz-hidden-unscrollable;
  -webkit-transition: 0.2s linear;
  transition: 0.2s linear;
}

.file-group {
  position: relative;
  overflow: hidden;
}

.publisher-btn {
  background-color: transparent;
  border: none;
  color: #cac7c7;
  font-size: 16px;
  cursor: pointer;
  overflow: -moz-hidden-unscrollable;
  -webkit-transition: 0.2s linear;
  transition: 0.2s linear;
}

.file-group input[type="file"] {
  position: absolute;
  opacity: 0;
  z-index: -1;
  width: 20px;
}

.text-info {
  color: #3d5b6e !important;
}
</style>